import DashboardIcon from '@mui/icons-material/Dashboard';
import { Breadcrumbs, Link, LinkProps, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { breadcrumbNameMap } from '../../constants';

interface LinkRouterProps extends LinkProps {
  to: string;
  replace?: boolean;
}

const LinkRouter = (props: LinkRouterProps): JSX.Element => (
  <Link {...props} component={RouterLink} />
);

const NavBreadcrumbs = (): JSX.Element => {
  const location = useLocation();
  const [pathNames, setPathNames] = useState<string[]>([]);

  useEffect(() => {
    setPathNames(location.pathname.split('/').filter((x) => x));
  }, [location]);

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ ml: 10 }}>
      <LinkRouter
        underline="hover"
        sx={{ display: 'flex', alignItems: 'center' }}
        color="inherit"
        to="/"
      >
        <DashboardIcon sx={{ mr: 0.5 }} fontSize="inherit" />
        Dashboard
      </LinkRouter>
      {pathNames.map((route, index) => {
        const last = index === pathNames.length - 1;
        const to = `/${pathNames.slice(0, index + 1).join('/')}`;
        return last ? (
          <Typography color="primary.main" key={to}>
            {breadcrumbNameMap[to]}
          </Typography>
        ) : (
          <LinkRouter
            underline="hover"
            sx={{ display: 'flex', alignItems: 'center' }}
            color="inherit"
            to={to}
            key={to}
          >
            {breadcrumbNameMap[to]}
          </LinkRouter>
        );
      })}
    </Breadcrumbs>
  );
};

export default NavBreadcrumbs;
